import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Radio } from "antd";
import { FileRow } from "./fileRow";
import { _swapFloors } from "../../shared/httpservice/apis";
const DraggableUploadContainer = ({ floors, fetchBuildingsAndFloors, defaultFloorId, alignClicked }) => {
    const [floorList, setFloorList] = useState(floors); // Manage the list of floors in state
    useEffect(() => {
        setFloorList(floors);
    }, [floors]);
    const handleSwap = (sourceId, targetId) => {
        const sourceIndex = floorList?.findIndex((floor) => floor?.floorId === sourceId);
        const targetIndex = floorList?.findIndex((floor) => floor?.floorId === targetId);
        if (sourceIndex !== -1 && targetIndex !== -1) {
            // Clone the floor objects to avoid modifying read-only properties
            const newFloorList = floorList?.map((floor) => ({ ...floor }));
            // Swap the elevation property of the cloned floor objects
            const sourceElevation = newFloorList[sourceIndex]["elevation"];
            const targetElevation = newFloorList[targetIndex]["elevation"];
            const floorId1 = newFloorList[sourceIndex]["floorId"];
            const floorId2 = newFloorList[targetIndex]["floorId"];
            newFloorList[sourceIndex]["elevation"] = targetElevation;
            newFloorList[targetIndex]["elevation"] = sourceElevation;
            // Swap the entire floor objects
            [newFloorList[sourceIndex], newFloorList[targetIndex]] = [
                newFloorList[targetIndex],
                newFloorList[sourceIndex],
            ];
            setFloorList(newFloorList); // Update state
            return _swapFloors(floorId1, floorId2);
        }
    };
    return (_jsx("div", { children: floorList?.map((item, index) => (_jsx(Radio.Group, { children: _jsx(FileRow, { isLastFloor: index === floorList.length - 1, data: item, onSwap: handleSwap, fetchBuildingsAndFloors: fetchBuildingsAndFloors, defaultFloorId: defaultFloorId, alignClicked: alignClicked, floors: floorList?.slice()?.reverse() }, item.floorId) }))) }));
};
export default DraggableUploadContainer;
